import React from "react";
import "../CSS/About.css";
import {
  FiCheckCircle,
  FiShield,
  FiClock,
  FiUsers,
  FiTrendingUp,
  FiZap,
  FiShoppingCart,
  FiHeart,
  FiBook,
  FiHome,
  FiTruck,
} from "react-icons/fi";

const About = () => {
  const valuesData = [
    {
      id: 1,
      icon: <FiCheckCircle />,
      title: "Excellence",
      description:
        "We pursue the highest standards in everything we do, from code quality to client communication.",
    },
    {
      id: 2,
      icon: <FiShield />,
      title: "Integrity",
      description:
        "Transparency, honesty, and ethical practices form the foundation of every client relationship.",
    },
    {
      id: 3,
      icon: <FiClock />,
      title: "Innovation",
      description:
        "We stay ahead of technology trends to deliver cutting-edge solutions that drive competitive advantage.",
    },
    {
      id: 4,
      icon: <FiUsers />,
      title: "Collaboration",
      description:
        "Success comes from working together—with clients, team members, and technology partners.",
    },
    {
      id: 5,
      icon: <FiTrendingUp />,
      title: "Results-Driven",
      description:
        "We measure our success by the tangible business outcomes we help our clients achieve.",
    },
    {
      id: 6,
      icon: <FiZap />,
      title: "Agility",
      description:
        "We adapt quickly to changing requirements and market conditions to keep projects on track.",
    },
  ];

  const industriesData = [
    {
      id: 1,
      icon: <FiShoppingCart />,
      title: "E-commerce & Retail",
      description:
        "Online stores, inventory management, and seamless payment processing solutions.",
    },
    {
      id: 2,
      icon: <FiTrendingUp />,
      title: "SaaS & Technology",
      description:
        "Scalable software platforms and enterprise technology solutions.",
    },
    {
      id: 3,
      icon: <FiHeart />,
      title: "Healthcare",
      description:
        "Patient management systems, telemedicine platforms, and health tracking apps.",
    },
    {
      id: 4,
      icon: <FiBook />,
      title: "Education",
      description:
        "E-learning platforms, course management, and online training systems.",
    },
    {
      id: 5,
      icon: <FiHome />,
      title: "Real Estate",
      description:
        "Property listings, virtual tours, and CRM solutions for real estate agencies.",
    },
    {
      id: 6,
      icon: <FiTruck />,
      title: "Logistics",
      description:
        "Supply chain management, fleet tracking, and delivery optimization systems.",
    },
  ];
  return (
    <>
      <title>About Syncnode | Engineering Digital Excellence - IT Services</title>
      <meta name="description" content="Syncnode is a strategic technology partner helping ambitious businesses transform through web development, Android apps, custom software, and automation solutions. Trusted by 50+ clients across diverse industries." />
      <meta name="keywords" content="about syncnode, IT services company, software development company, web development, android development, technology partner, digital transformation, enterprise solutions" />
      <link rel="canonical" href="https://www.syncnode.in/about" />
      <meta property="og:title" content="About Syncnode | Engineering Digital Excellence" />
      <meta property="og:description" content="Strategic technology partner delivering web development, Android apps, custom software, and automation. 30+ projects delivered, 99% satisfaction rate, 24/7 support." />
      <meta property="og:url" content="https://www.syncnode.in/about" />
      <meta property="og:type" content="website" />
      <div className="about_wrapper">
        <div className="container">
          <div className="about_banner">
            <h1>
              Building the <span className="decorated_text">Future</span>{" "}
              Together
            </h1>
            <p className="intro_text">
              We're a team of strategists, designers, and engineers passionate
              about transforming businesses through innovative technology
              solutions.
            </p>
          </div>

          <div className="company_info">
            <p className="sub_title">Our Story</p>
            <h1 className="title">Who We Are</h1>
            <p className="section_intro">
              Comprehensive digital solutions engineered to accelerate your
              business objectives.
            </p>

            <div className="info_content">
              <p>
                Founded with a vision to bridge the gap between business
                ambitions and technological possibilities, Syncnode has evolved
                into a trusted partner for enterprises seeking digital
                transformation. We combine strategic thinking with technical
                excellence to deliver solutions that drive real business
                outcomes.
              </p>
              <p>
                Our journey began with a simple belief: technology should
                empower businesses, not complicate them. This philosophy guides
                every project we undertake, from initial consultation to final
                deployment and beyond
              </p>
              <p>
                Today, we serve clients across diverse industries, helping them
                navigate the complexities of digital transformation with
                confidence. Our success is measured not just by the solutions we
                deliver, but by the lasting partnerships we build and the
                tangible results our clients achieve.
              </p>
            </div>
          </div>

          <div className="about_stats">
            <div className="row mt30">
              <div className="item">
                <h2 className="text_center">30+</h2>
                <p>Successfully completed projects across industries</p>
              </div>
              <div className="item">
                <h2 className="text_center">50+</h2>
                <p>Businesses trust us with their digital presence</p>
              </div>
              <div className="item">
                <h2 className="text_center">99%</h2>
                <p>Client satisfaction and retention score</p>
              </div>
              <div className="item">
                <h2 className="text_center">24/7</h2>
                <p>Support available to immediately resolve client queries</p>
              </div>
            </div>
          </div>

          <div className="about_drive">
            <p className="sub_title">Our Values</p>
            <h1 className="title">What Drives Us</h1>
            <p className="section_intro">
              The principles that guide our work and define our culture.
            </p>

            <div className="drive_row">
              {valuesData.map((value) => (
                <div className="drive_item" key={value.id}>
                  <div className="drive_icon">{value.icon}</div>
                  <h3>{value.title}</h3>
                  <p>{value.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="about_industries">
            <p className="sub_title">Industries</p>
            <h1 className="title">Industries We Serve</h1>
            <p className="section_intro">
              Delivering specialized solutions across diverse sectors and
              business verticals.
            </p>

            <div className="industries_row">
              {industriesData.map((industry) => (
                <div className="industries_item" key={industry.id}>
                  <div className="industries_icon">{industry.icon}</div>
                  <h3>{industry.title}</h3>
                  <p>{industry.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
